import { API_URL } from '../config/urlConfig';
import DefaultAvatar from '../assets/icons/default-avatar.png';

/**
 * Resolve o endereço de exibição do avatar.
 *
 * Precisa aceitar as duas formas porque o banco tem as duas: caminho relativo
 * (`/uploads/avatars/...`) nas contas anteriores ao object storage, e URL
 * absoluta depois dele. Enquanto a migração dos arquivos antigos não rodar, as
 * duas convivem.
 *
 * Estava duplicado: o AppShell checava `startsWith('http')` e o UserSettings
 * concatenava direto com a API — o que produziria
 * `https://api.silentpuma.comhttps://...` no dia em que a primeira URL absoluta
 * aparecesse.
 */
export const urlDoAvatar = (caminho) => {
  if (!caminho) return DefaultAvatar;
  return /^https?:\/\//.test(caminho) ? caminho : `${API_URL}${caminho}`;
};

export { DefaultAvatar };
